import React, { useEffect, useState, memo, useMemo } from 'react';
import { Task, TaskStatus } from '../types';
import { Button, ButtonStatus } from '@/components/Button/Button';
import styles from './TaskItem.module.scss';
import { ReactComponent as StarIcon } from '@/assets/Icons/star.svg';
import { claimBarzhaTask } from '../../../api/modules/Tasks/barzha';
// import { BannerCpcAdapter } from '../adapters/sponsors/BannerCpcAdapter';
import { barzaBoostProvider } from '../adapters/sponsors/boost/BarzaBoostProvider';
import { useNotificationStore } from '../../../store/NotificationStore';
import { SponsorsService } from '../services/SponsorsService';
import { tadsClickSend } from '../../../api/modules/Tasks/barzha';
import { richAdsClickSend } from '../../../Services/richads';
import {
  claimCpmReward,
  SendCPMInfo,
} from '../../../api/modules/Tasks/banner_cpm';

import {
  claimBannerCpcTask,
  getBannerCpcTasks,
} from '../../../api/modules/Tasks/banner_cpc';

import axios from 'axios';
import { TasksService } from '../../../Services/TasksService';
import { useBoostTaskStore } from '../../../store/BoostMaxStore';
import { useModalStore as useNormalModalStore } from '../../../store/NormalModalStore';
import { useProgressStore } from '@/store/ProgressStore';
import { TimeDisplay } from '@/utils/TimeDisplay';
import { adsgramCpcClickSend } from '@/Services/adsgramcpc';
import useLimitStore from '@/store/LimitStore';
import TaskActionModal from '@/components/TaskActionModal/TaskActionModal';
import WebApp from '@twa-dev/sdk';
import cpmicon from '../../../assets/Icons/cpmIconNew.png';
import cpcicon from '../../../assets/Icons/cpcIconNew.png';
import { claimSponsorTask } from '@/api/modules/Tasks/sponsors';

declare global {
  interface Window {
    tads?: any;
  }
}

interface TaskItemProps {
  task: Task;
  onClaim: (taskId: string | number) => Promise<void>;
}

const TaskItemInner: React.FC<TaskItemProps> = ({ task, onClaim }) => {
  // console.log('🎯 TaskItem: Rendering task:', task);

  const [isProcessing, setIsProcessing] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState<number | undefined>(
    task.timeRemaining,
  );
  const { setNotification } = useNotificationStore();
  const limit = useLimitStore((state) => state.limit);
  const setLimit = useLimitStore((state) => state.setLimit);
  // Локальный UI-стейт для статуса и текста кнопки
  const [localStatus, setLocalStatus] = useState<TaskStatus>(task.status);
  const [localButtonText, setLocalButtonText] = useState<string>(
    task.buttonText ?? '',
  );

  const [cpmSleep, setCpmSleep] = useState(false);
  const [cpcSleep, setCpcSleep] = useState(false);
  const [cpmTime, setCpmTime] = useState<string>('');
  const [cpcTime, setCpcTime] = useState<string>('');

  // Разделенные состояния прогресса для разных типов задач
  const [localCPMProgress, setLocalCPMProgress] = useState(
    task.provider === 'BANNER_CPM' ? task.progress?.current || 0 : 0,
  );
  const cpcProgress = useProgressStore((state) => state.cpcProgress);
  const setCpcProgress = useProgressStore((state) => state.setCpcProgress);

  // Функция для получения текущего прогресса в зависимости от типа задачи
  const getCurrentProgress = useMemo(() => {
    if (task.provider === 'BANNER_CPM') {
      return localCPMProgress;
    } else if (task.provider === 'BANNER_CPC') {
      return cpcProgress;
    }
    return task.progress?.current || 0;
  }, [task.provider, localCPMProgress, cpcProgress, task.progress?.current]);

  // Синхронизация локального стейта с пропсами
  useEffect(() => {
    setLocalStatus(task.status);
    setLocalButtonText(task.buttonText ?? '');
    setTimeRemaining(task.timeRemaining);

    // Обновляем соответствующий прогресс в зависимости от типа задачи
    if (task.provider === 'BANNER_CPM') {
      setLocalCPMProgress(task.progress?.current || 0);
    } else if (task.provider === 'BANNER_CPC') {
      setCpcProgress(task.progress?.current || 0);
    }
    console.log(task);
  }, [task]);

  useEffect(() => {
    if (task.provider === 'BANNER_CPM' && task.status === 'SLEEP') {
      setCpmSleep(true);
      setLocalCPMProgress(30);
      setCpmTime(task.date_end || '');
    }
    if (task.provider === 'BANNER_CPC' && task.status === 'SLEEP') {
      setCpcSleep(true);
      setCpcProgress(10);
      setCpcTime(task.date_end || '');
    }
  }, [task]);

  // --- Отслеживание закрытия RichAds баннера (крестик) ---
  useEffect(() => {
    const handleRichAdsClose = () => {
      if (isProcessing) {
        setIsProcessing(false);
      }
    };
    window.addEventListener('richads-close-clicked', handleRichAdsClose);
    return () => {
      window.removeEventListener('richads-close-clicked', handleRichAdsClose);
    };
  }, [isProcessing, setNotification]);

  const handleBannerCpc = async () => {
    try {
      const availableTasks = await TasksService.getAllAvailableTasksNoCpm();
      console.log('Доступные задачи:', availableTasks);
      console.log('Количество задач:', availableTasks.length);
      if (availableTasks.length > 0) {
        for (const task of availableTasks) {
          const showGenericModal =
            task.provider === 'Barza' ||
            task.provider === 'TappAds' ||
            task.provider === 'DreamCoin' ||
            task.provider === 'Barzha' ||
            task.provider === 'Flyer';

          if (showGenericModal) {
            console.log('Открываем модальное окно для рекламы');
            console.log('Task для модалки:', task);
            useBoostTaskStore.getState().setCurrentTask(task);
            useNormalModalStore.getState().setOpen('boost');
            console.log('Модалка должна открыться');

            break;
          } else {
            console.log('Прямой показ рекламы');
            const result = await task.onClick();
            console.log('Результат показа рекламы:', result);
            if (result === 'success') {
              if (task.provider === 'Tads') {
                const res = await tadsClickSend();
                setCpcProgress(res.data.task.user_progress);
                setNotification({
                  type: 'Success',
                  message: 'Прогресс засчитан',
                });
              }
              if (task.provider === 'RichAds') {
                const res = await richAdsClickSend();
                setCpcProgress(res.data.task.user_progress);
                setNotification({
                  type: 'Success',
                  message: 'Прогресс засчитан',
                });
              }
              if (task.provider === 'AdsgramCPC') {
                const res = await adsgramCpcClickSend();
                setCpcProgress(res.data.task.user_progress);
                setNotification({
                  type: 'Success',
                  message: 'Прогресс засчитан',
                });
              }

              break;
            } else if (result === 'user_cancelled') {
              break;
            } else if (
              result === 'ads_not_found' &&
              task.provider === 'RichAds'
            ) {
              setNotification({
                type: 'Error',
                message: 'Реклама не найдена!',
              });
              break;
            }
          }
        }
      } else {
        setNotification({
          type: 'Error',
          message: 'Нет доступных заданий',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleBannerCpcClaim = async () => {
    try {
      const syncTasks = await getBannerCpcTasks();
      const firstTaskId = syncTasks.tasks?.[0]?.id;
      if (!firstTaskId) {
        setNotification({
          type: 'Error',
          message: 'Не найден id первой CPC задачи',
        });
        return;
      }
      const claimRes = await claimBannerCpcTask(Number(firstTaskId));
      if (!claimRes || claimRes.success === false) {
        setNotification({ type: 'Error', message: 'Ошибка claim CPC' });
        return;
      }
      console.log(claimRes, 'РЕЗУЛЬТАТ СПС');
      setCpcSleep(true);
      setCpcTime(claimRes.data?.[0]?.details.sleep_time_end || '');
      setNotification({
        type: 'Success',
        message: 'Награда успешно получена!',
      });

      setCpcProgress(10);
    } catch (e) {
      setNotification({
        type: 'Error',
        message: 'Награда не получена',
      });
      console.error('[CPC] Ошибка claim:', e);
    }
  };

  // const handleFlyerCpcClaim = async () => {
  //   console.log('handleBOBOBOBOOBOB');
  //   try {
  //     const syncTasks = await getFlyerCpcTasks();
  //     const firstTaskId = syncTasks.tasks?.[0]?.id;
  //     console.log(firstTaskId);
  //     if (!firstTaskId) {
  //       setNotification({
  //         type: 'Error',
  //         message: 'Не найден id первой Flyer CPC задачи',
  //       });
  //       return;
  //     }
  //     await claimFlyerCpcTask(Number(firstTaskId));
  //     setNotification({
  //       type: 'Success',
  //       message: 'Награда успешно получена!',
  //     });
  //     setLocalProgress(0); // Обнуляем каунтер после claim
  //     setShowFlyerCpc(false); // Закрыть модалку для Flyer CPC
  //     // Убираем кулдаун для CPC задач
  //     // startCooldown(10);
  //     // Синхронизируем с сервером
  //     const syncTasksAfter = await getFlyerCpcTasks();
  //     const syncTask = syncTasksAfter.tasks.find(
  //       (tt: any) => String(tt.id) === String(task.id),
  //     );
  //     if (syncTask) setLocalProgress(syncTask.user_progress || 0);
  //   } catch (e) {
  //     setNotification({
  //       type: 'Error',
  //       message: 'Ошибка выполнения claim Flyer CPC',
  //     });
  //     console.error('[FLYER_CPC] Ошибка claim:', e);
  //   }
  // };

  const handleBannerCpmClaim = async () => {
    try {
      const res = await claimCpmReward();
      setNotification({
        type: 'Success',
        message: 'Награда успешно получена!',
      });
      setLocalCPMProgress(30);
      if (Array.isArray(res.data) && res.data[0]?.status === 'sleep') {
        setCpmSleep(true);
        console.log(res.data[0], 'РЕЗУЛЬТАТ СПМ');
        setCpmTime(res.data[0]?.details.sleep_time_end || '');
      } else {
        setCpmSleep(false);
      }
      console.log(res);
    } catch (e) {
      console.error('Ошибка!', e);
    }
  };

  const handleBannerCpm = async () => {
    // Локальный замок для этого конкретного вызова функции
    let adShown = false;
    try {
      const availableTasks =
        limit >= 20
          ? await TasksService.getAllAvailableTasksNoCpcAndOnclick()
          : await TasksService.getAllAvailableTasksNoCpc();
      console.log('availableTasksERE', availableTasks);
      if (availableTasks.length > 0) {
        for (const task of availableTasks) {
          // Если уже показали рекламу в этом вызове — прекращаем
          if (adShown) {
            break;
          }
          const result: 'success' | 'user_cancelled' | 'ads_not_found' =
            await task.onClick();
          if (result === 'success') {
            try {
              const res = await SendCPMInfo(task.provider);
              if (res.data?.task.user_progress) {
                setLocalCPMProgress(res.data?.task.user_progress);
                setNotification({
                  type: 'Success',
                  message: 'Прогресс засчитан',
                });
              }
              if (task.provider === 'onclick') {
                console.log(limit, 'LIT before');
                const newLimit = limit + 1;
                setLimit(newLimit);
                console.log(newLimit, 'LIT!!!!!');
              }
              // Успех: помечаем что реклама показана в этом вызове
              adShown = true;
            } catch (error) {
              console.error('Ошибка!', error);
            }
            break;
          } else if (result === 'user_cancelled') {
            // Отмена: помечаем что реклама показана в этом вызове
            adShown = true;
            break;
          } else if (result === 'ads_not_found') {
            console.log(
              `Реклама не найдена у ${task.provider}, пробуем следующий провайдер`,
            );
            if (availableTasks.length === 1) {
              setNotification({
                type: 'Error',
                message: 'Реклама не найдена!',
              });
              break;
            }
            // ads_not_found: продолжаем к следующему провайдеру
            continue;
          }
        }
      } else {
        setNotification({
          type: 'Error',
          message: 'Нет доступных задач для просмотра рекламы',
        });
      }
    } catch (error) {
      console.error('Ошибка в handleBannerCpm:', error);
      setNotification({
        type: 'Error',
        message: 'Ошибка при просмотре рекламы',
      });
    }
  };

  const handleBarzha = async () => {
    try {
      const result = await barzaBoostProvider.startTask(task.id);
      if (result === 'ads_not_found') {
        setNotification({
          type: 'Error',
          message: 'Реклама не найдена',
        });
      }
    } catch (error) {
      console.error('Error in handleBarzha:', error);
      setNotification({
        type: 'Error',
        message: 'Ошибка при старте задания',
      });
    }
  };

  const [showTads] = useState(false);
  const [tadsReady, setTadsReady] = useState(false);
  const isDev = process.env.NODE_ENV === 'development';
  const [tadsLoading, setTadsLoading] = useState(false);

  const TADS_API_URL = isDev
    ? 'https://npibfkrxceijfavmsstr-rr-ap-southeast-1-sdvqm.supabase.co/rest/v1/rpc/test_ads?apikey=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5waWJma3J4Y2VpamZhdm1zc3RyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTgwMzY2NjksImV4cCI6MjAzMzYxMjY2OX0.tzFCWLAgY6nEVB8mMqHnNBn3p4iYXt9Z5U6lpE_1Iz0&wid=554&platform=web&locale=ru&uid=638107431&is_premium=true&is_rewarded=true&referrer=https%3A%2F%2Ftestt-mini-app.ngrok.dev'
    : '/api/tads/ads';

  useEffect(() => {
    if (showTads) {
      setTadsLoading(true);
      axios
        .get(TADS_API_URL)
        .then((res) => {
          const ad = res.data?.ads?.[0];
          console.log('data', ad);
        })
        .catch(() => {})
        .finally(() => {
          setTadsLoading(false);
          setTadsReady(true); // Теперь можно показывать модалку
        });
    } else {
      setTadsReady(false);
    }
  }, [showTads]);

  // --- Task Action Modal state ---
  const [showTaskModal, setShowTaskModal] = useState(false);

  // --- Универсальная функция для обработки task.id ---
  const getTaskId = (id: string | number): string | number => {
    // Если это строка, которая является числом - конвертируем в число
    if (typeof id === 'string' && !isNaN(Number(id))) {
      return Number(id);
    }
    // Если это строка, которая не число - оставляем строкой
    if (typeof id === 'string') {
      return id;
    }
    // Если это число - оставляем числом
    return id;
  };

  const handleExecuteTask = async () => {
    if (WebApp && (WebApp as any).HapticFeedback) {
      (WebApp as any).HapticFeedback.notificationOccurred('success');
    }
    setIsProcessing(true);
    try {
      switch (task.provider) {
        case 'BARZHA':
          await handleBarzha();
          break;
        case 'FLYER':
          // Выполняем задание без изменения статуса кнопки
          if (task.link?.includes('t.me/')) {
            window?.Telegram?.WebApp?.openTelegramLink(task.link);
          } else {
            window.open(task.link, '_blank');
          }
          SponsorsService.updateFlyerTaskStatus(task.id, 'CHECK');
          // НЕ меняем localStatus и localButtonText - кнопка остается с прежними стилями
          break;
        case 'SPONSORS':
          // Выполняем задание без изменения статуса кнопки
          if (task.link?.includes('t.me/')) {
            window?.Telegram?.WebApp?.openTelegramLink(task.link);
          } else {
            window.open(task.link, '_blank');
          }
          // НЕ меняем localStatus и localButtonText - кнопка остается с прежними стилями
          break;
        default:
          if (task.link) {
            if (task.link?.includes('t.me/')) {
              window?.Telegram?.WebApp?.openTelegramLink(task.link);
            } else {
              window.open(task.link, '_blank');
            }
          }
      }
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCheckTask = async () => {
    if (WebApp && (WebApp as any).HapticFeedback) {
      (WebApp as any).HapticFeedback.notificationOccurred('success');
    }
    if (task.provider === 'BARZHA') {
      setNotification({
        type: 'Warning',
        message: 'Задание на проверке, повтори попытку через 30 секунд.',
      });
      setIsProcessing(false);
      setShowTaskModal(false);
      return;
    }
    setIsProcessing(true);
    try {
      let success = false;
      if (task.provider === 'FLYER') {
        const res = await SponsorsService.checkFlyerTaskStatus(task.id);
        if (res.status === 'claim') {
          const taskId = getTaskId(task.id);
          await SponsorsService.claimSponsorTask(taskId);
          setLocalStatus('CLAIMED');
          setLocalButtonText('Выполнено');
          setNotification({
            type: 'Success',
            message: 'Награда успешно получена!',
          });
          success = true;
        } else {
          setLocalStatus('IN_PROGRESS');
          setLocalButtonText('Проверка');
          if (task.id.toString().includes('boost')) {
            setNotification({
              type: 'Warning',
              message: 'Твой буст будет засчитан в течение 10 минут.',
            });
          } else {
            setNotification({
              type: 'Warning',
              message:
                'Задание на проверке, оставайся подписанным на канал в течение 24 часов, чтобы получить награду.',
            });
          }
          success = true;
        }
      } else if (task.type === 'sponsor-subs') {
        const taskId = getTaskId(task.id);
        const res = await claimSponsorTask(taskId as number);

        if (res.data.status === 'waiting') {
          setLocalStatus('IN_PROGRESS');
          setLocalButtonText('Проверка');
          setNotification({
            type: 'Warning',
            message:
              'Задание на проверке, оставайся подписанным на канал в течение 24 часов, чтобы получить награду.',
          });
          success = true;
        } else {
          setLocalStatus('CLAIMED');
          setLocalButtonText('Выполнено');
          setNotification({
            type: 'Success',
            message: 'Награда успешно получена!',
          });
          success = true;
        }
      } else {
        const taskId = getTaskId(task.id);
        await SponsorsService.claimSponsorTask(taskId as number);
        setLocalStatus('CLAIMED');
        setLocalButtonText('Выполнено');
        setNotification({
          type: 'Success',
          message: 'Награда успешно получена!',
        });
        success = true;
      }
      if (success) {
        setShowTaskModal(false);
      }
    } catch (error) {
      setNotification({
        type: 'Error',
        message: 'Ошибка проверки задания',
      });
    } finally {
      setIsProcessing(false);
    }
  };

  // --- Единый обработчик клика ---

  const handleClaim = async () => {
    if (WebApp && (WebApp as any).HapticFeedback) {
      (WebApp as any).HapticFeedback.notificationOccurred('success');
    }
    if (localStatus === 'CLAIMED' || isProcessing) return;
    setIsProcessing(true);
    try {
      switch (task.provider) {
        case 'BANNER_CPC':
          await handleBannerCpcClaim();
          break;
        case 'BANNER_CPM':
          await handleBannerCpmClaim();
          break;
        default: {
          const taskId = getTaskId(task.id);
          const res = await onClaim(taskId);
          console.log(res, 'res');
          setLocalStatus('CLAIMED');
          setLocalButtonText('Выполнено');
          setNotification({
            type: 'Success',
            message: 'Награда успешно получена!',
          });
        }
      }
    } finally {
      setIsProcessing(false);
      setShowTaskModal(false);
    }
  };

  const handleClick = async () => {
    if (WebApp && (WebApp as any).HapticFeedback) {
      (WebApp as any).HapticFeedback.notificationOccurred('success');
    }
    // Для CPC и CPM заданий - старая логика
    if (task.provider === 'BANNER_CPC' || task.provider === 'BANNER_CPM') {
      // Проверяем все возможные блокировки только для CPM
      if (task.provider === 'BANNER_CPM') {
        if (localStatus === 'CLAIMED' || isProcessing) return;
        // Таймер только для CPM
        if (timeRemaining && timeRemaining > 0) return;
      } else {
        // Для остальных задач проверяем только базовые блокировки
        if (localStatus === 'CLAIMED' || isProcessing) return;
      }

      setIsProcessing(true);

      try {
        switch (task.provider) {
          case 'BANNER_CPC':
            await handleBannerCpc();
            break;
          case 'BANNER_CPM':
            await handleBannerCpm();
            break;
        }
      } finally {
        setIsProcessing(false);
      }
    } else {
      // Для всех остальных заданий
      if (localStatus === 'CLAIMED' || isProcessing) return;
      // Если задание готово к сбору — сразу собираем
      if (getButtonText === 'Собрать' || localStatus === 'DONE') {
        await handleClaim();
      } else {
        // Иначе открываем модалку
        setShowTaskModal(true);
      }
    }
  };

  // --- Вспомогательные функции ---

  // Исправлено: claim только при точном совпадении current === total
  const isAtLimit = useMemo(
    () => task.progress && getCurrentProgress === task.progress.total,
    [task.progress, getCurrentProgress],
  );
  const getButtonText = useMemo(() => {
    // Загрузка для CPC и CPM задач
    if (
      isProcessing &&
      ((task.provider as string) === 'BANNER_CPC' ||
        (task.provider as string) === 'BANNER_CPM')
    ) {
      return 'Загрузка...';
    }

    if (
      isAtLimit &&
      (task.provider === 'BANNER_CPC' || task.provider === 'BANNER_CPM')
    )
      return 'Собрать';
    // Для Barzha: если статус claim — "Собрать"
    if (task.provider === 'BARZHA' && localStatus === 'DONE') {
      return 'Собрать';
    }
    if (task.provider === 'FLYER' && localStatus === 'DONE') {
      return 'Собрать';
    }
    if (task.type === 'sponsor-subs' && localStatus === 'DONE') {
      return 'Собрать';
    }

    // Для BANNER_CPC и BANNER_CPM всегда "Выполнить", даже если DONE
    if (
      (task.provider as string) === 'BANNER_CPC' ||
      (task.provider as string) === 'BANNER_CPM'
    ) {
      return 'Выполнить';
    }

    if (localStatus === 'DONE') {
      if (task.provider === 'SPONSORS' || task.provider === 'BARZHA') {
        return 'Выполнено';
      }
      return 'Выполнен';
    }

    // Специальный случай "Посмотреть"
    if ((task.provider as string) === 'BANNER_CPM') return 'Посмотреть';

    return localButtonText;
  }, [isProcessing, task.provider, isAtLimit, localStatus, localButtonText]);

  const getButtonStatus = useMemo(
    () =>
      (status: TaskStatus): ButtonStatus => {
        switch (status) {
          case 'NOT_STARTED':
            return 'not_started';
          case 'IN_PROGRESS':
            return 'in_progress';
          case 'DONE':
            return 'done';
          case 'CHECK':
            return 'check';
          case 'CLAIMED':
            return 'claim';
          default:
            return 'not_started';
        }
      },
    [],
  );

  const isButtonDisabled = useMemo(
    () =>
      localStatus === 'CLAIMED' ||
      isProcessing ||
      // Таймеры только для CPM
      ((task.provider as string) === 'BANNER_CPM' &&
        timeRemaining !== undefined &&
        timeRemaining > 0),
    [localStatus, isProcessing, task.provider, timeRemaining],
  );

  return (
    <>
      <div className={styles.taskItem}>
        {task.progress && task.progress.total > 1 && (
          <div className={styles.taskItem__progress}>
            <div className={styles.taskItem__progressBar}>
              <div
                className={styles.taskItem__progressFill}
                style={{
                  width: `${(getCurrentProgress / task.progress.total) * 100}%`,
                }}
              />
            </div>
            <div className={styles.taskItem__progressText}>
              {getCurrentProgress}/{task.progress.total}
            </div>
          </div>
        )}
        <div className={styles.taskItem__content}>
          <div className={styles.taskItem__info}>
            {task.icon ? (
              <img
                className={styles['taskItem__avatar']}
                src={task.icon}
                alt={task.title}
              />
            ) : (
              <div
                className={`${styles['taskItem__icon']} ${
                  task.provider === 'BANNER_CPM' ||
                  task.provider === 'BANNER_CPC'
                    ? styles['taskItem__icon--gray']
                    : ''
                }`}
              >
                {task.provider === 'BANNER_CPM' ? (
                  <img src={cpmicon} alt="CPM" />
                ) : task.provider === 'BANNER_CPC' ? (
                  <img src={cpcicon} alt="CPC" />
                ) : (
                  <div className={styles.taskItem__iconText}>
                    {(() => {
                      const title = task.title || '';
                      for (let i = 0; i < title.length; i++) {
                        const char = title[i];
                        if (/[a-zA-Zа-яА-Я0-9]/.test(char)) {
                          return char.toUpperCase();
                        }
                      }
                      return title.charAt(0).toUpperCase();
                    })()}
                  </div>
                )}
              </div>
            )}
            <div className={styles.taskItem__text}>
              <div className={styles.taskItem__title}>{task.title}</div>
              {task.rewards?.stars && task.rewards.stars > 0 ? (
                <div className={styles.taskItem__rewards}>
                  +<StarIcon />
                  {task.rewards.stars}
                </div>
              ) : (
                <div className={styles.taskItem__rewards}>
                  <span style={{ color: '#999', fontSize: '12px' }}>
                    Без награды
                  </span>
                </div>
              )}
            </div>
          </div>
          {/* --- Новое условие для sleep CPM --- */}
          {cpmSleep && task.provider === 'BANNER_CPM' ? (
            <div style={{ opacity: 0.5 }}>
              <TimeDisplay endDate={cpmTime} format="short" />
            </div>
          ) : cpcSleep && task.provider === 'BANNER_CPC' ? (
            <div style={{ opacity: 0.5 }}>
              <TimeDisplay endDate={cpcTime} format="short" />
            </div>
          ) : isAtLimit &&
            (task.provider === 'BANNER_CPC' ||
              task.provider === 'BANNER_CPM') ? (
            <Button
              status="done"
              disabled={isButtonDisabled || isProcessing}
              onClick={handleClaim}
              className={styles.taskItem__button}
              buttonText="Собрать"
            />
          ) : (
            <Button
              status={getButtonStatus(localStatus)}
              disabled={isButtonDisabled || isProcessing}
              onClick={getButtonText === 'Собрать' ? handleClaim : handleClick}
              className={styles.taskItem__button}
              buttonText={getButtonText}
            />
          )}
        </div>
      </div>
      {/* {open === 'boost' && currentTask && (
        <Modal
          open={open === 'boost'}
          onClose={() => {
            setOpen(false);
            setCurrentTask(null);
          }}
        >
          <TaskModal
            task={currentTask}
            onClose={() => {
              setOpen(false);
              setCurrentTask(null);
            }}
          />
        </Modal>
      )} */}
      {showTads && tadsReady && !tadsLoading && (
        // <div
        //   style={{
        //     position: 'fixed',
        //     zIndex: 99999,
        //     left: 0,
        //     top: 0,
        //     width: '100vw',
        //     height: '100vh',
        //     background: 'rgba(0,0,0,0.7)',
        //     display: 'flex',
        //     alignItems: 'flex-end',
        //     justifyContent: 'center',
        //   }}
        // >
        //   <div
        //     style={{
        //       background: '#222',
        //       borderRadius: 16,
        //       padding: '4vw 4vw 5vw 4vw',
        //       minWidth: 0,
        //       minHeight: 120,
        //       position: 'relative',
        //       maxWidth: 420,
        //       width: '96vw',
        //       marginBottom: '4vw',
        //       boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
        //       boxSizing: 'border-box',
        //     }}
        //   >
        //     <button
        //       onClick={() => setShowTads(false)}
        //       style={{
        //         position: 'absolute',
        //         top: 12,
        //         right: 12,
        //         background: 'transparent',
        //         border: 'none',
        //         color: '#fff',
        //         fontSize: 28,
        //         cursor: 'pointer',
        //         zIndex: 2,
        //       }}
        //     >
        //       ×
        //     </button>
        //     {/* Текст и виджет одновременно после tadsReady */}
        //     <div
        //       style={{
        //         textAlign: 'center',
        //         marginTop: '4vw',
        //         marginBottom: '6vw',
        //         fontWeight: 700,
        //         fontSize: 'clamp(16px, 4vw, 22px)',
        //         width: '76vw',
        //         maxWidth: 340,
        //         marginLeft: 'auto',
        //         marginRight: 'auto',
        //       }}
        //     >
        //       Нажми на баннер, чтобы выполнить задание
        //     </div>
        //     <div
        //       style={{
        //         display: 'flex',
        //         flexDirection: 'column',
        //         alignItems: 'center',
        //         justifyContent: 'center',
        //         width: '100%',
        //         maxWidth: 340,
        //         margin: '0 auto 24px auto',
        //         boxSizing: 'border-box',
        //       }}
        //     >
        //       <TadsWidget
        //         id="554"
        //         debug={true}
        //         onClickReward={async () => {
        //           try {
        //             const syncTasks = await getBannerCpcTasks();
        //             const firstTask = syncTasks.tasks?.[0];
        //             if (!firstTask) {
        //               setNotification({
        //                 type: 'Error',
        //                 message: 'Не найден id первой CPC задачи',
        //               });
        //               return;
        //             }
        //             // Если задача завершена — claim
        //             if (
        //               typeof firstTask.user_progress === 'number' &&
        //               typeof firstTask.target_progress === 'number' &&
        //               firstTask.user_progress >= firstTask.target_progress &&
        //               (firstTask.status === 'claim' ||
        //                 firstTask.status === 'claimed')
        //             ) {
        //               const claimRes = await claimBannerCpcTask(
        //                 Number(firstTask.id),
        //               );
        //               if (!claimRes || claimRes.success === false) {
        //                 setNotification({
        //                   type: 'Error',
        //                   message: 'Tads: ошибка claim',
        //                 });
        //                 return;
        //               }
        //               setLocalProgress((prev) => prev + 1);
        //               setShowTads(false); // Закрываем модалку после claim
        //             } else {
        //               // Иначе просто клик
        //               const clickRes = await clickBannerCpcTask();
        //               if (!clickRes || clickRes.success === false) {
        //                 setNotification({
        //                   type: 'Error',
        //                   message: 'Tads: ошибка click',
        //                 });
        //                 return;
        //               }
        //               setLocalProgress((prev) => prev + 1);
        //               setShowTads(false); // Закрываем модалку после click
        //             }
        //           } catch (e) {
        //             setNotification({
        //               type: 'Error',
        //               message: 'Tads: ошибка выполнения',
        //             });
        //             console.error('[Tads] Ошибка в onClickReward:', e);
        //           }
        //         }}
        //         onAdsNotFound={() => {
        //           setShowTads(false);
        //           setNotification({
        //             type: 'Error',
        //             message: 'Tads: не найдено рекламы',
        //           });
        //         }}
        //       />
        //     </div>
        //     <div
        //       style={{
        //         fontSize: 'clamp(14px, 2.5vw, 13px)',
        //         marginBottom: '3vw',
        //         marginTop: '6vw',
        //         textAlign: 'center',
        //       }}
        //     >
        //       *Остерегайтесь мошенников, подписываться необязательно.
        //     </div>
        //   </div>
        // </div>
        <></>
      )}
      {/* {showBarzha && (
        <div
          style={{
            position: 'fixed',
            zIndex: 99999,
            left: 0,
            top: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.7)',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              background: '#222',
              borderRadius: 16,
              padding: '4vw 4vw 5vw 4vw',
              minWidth: 0,
              minHeight: 120,
              position: 'relative',
              maxWidth: 420,
              width: '96vw',
              marginBottom: '4vw',
              boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
              boxSizing: 'border-box',
            }}
          >
            <button
              onClick={() => setShowBarzha(false)}
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                background: 'transparent',
                border: 'none',
                color: '#fff',
                fontSize: 28,
                cursor: 'pointer',
                zIndex: 2,
              }}
            >
              ×
            </button>
            <div
              style={{
                textAlign: 'center',
                marginTop: '4vw',
                marginBottom: '6vw',
                fontWeight: 700,
                fontSize: 'clamp(16px, 4vw, 22px)',
                width: '76vw',
                maxWidth: 340,
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              Нажми на баннер, чтобы выполнить задание
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                maxWidth: 340,
                margin: '0 auto 24px auto',
                boxSizing: 'border-box',
              }}
            >
              <AdMasterWidget
                widgetId={67}
                handleClick={() => {
                  setShowBarzha(false);
                  setCpcProgress((prev) => prev + 1);
                }}
              />
            </div>
            <div
              style={{
                fontSize: 'clamp(14px, 2.5vw, 13px)',
                marginBottom: '3vw',
                marginTop: '6vw',
                textAlign: 'center',
              }}
            >
              *Остерегайтесь мошенников, подписываться необязательно.
            </div>
          </div>
        </div>
      )}
      {showTads && !tadsReady && (
        <div
          style={{
            position: 'fixed',
            zIndex: 99999,
            left: 0,
            top: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.7)',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              background: '#222',
              borderRadius: 16,
              padding: '4vw',
              minWidth: 0,
              minHeight: 120,
              position: 'relative',
              maxWidth: 420,
              width: '96vw',
              marginBottom: '4vw',
              boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
              boxSizing: 'border-box',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span style={{ color: '#fff', fontSize: 18 }}>Загрузка...</span>
          </div>
        </div>
      )}
      {showFlyerCpc && (
        <div
          style={{
            position: 'fixed',
            zIndex: 99999,
            left: 0,
            top: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.7)',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              background: '#222',
              borderRadius: 16,
              padding: '4vw 4vw 5vw 4vw',
              minWidth: 0,
              minHeight: 120,
              position: 'relative',
              maxWidth: 420,
              width: '96vw',
              marginBottom: '4vw',
              boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
              boxSizing: 'border-box',
            }}
          >
            <button
              onClick={() => setShowFlyerCpc(false)}
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                background: 'transparent',
                border: 'none',
                color: '#fff',
                fontSize: 28,
                cursor: 'pointer',
                zIndex: 2,
              }}
            >
              ×
            </button>
            <div
              style={{
                textAlign: 'center',
                marginTop: '4vw',
                marginBottom: '6vw',
                fontWeight: 700,
                fontSize: 'clamp(16px, 4vw, 22px)',
                width: '76vw',
                maxWidth: 340,
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              Нажми на баннер, чтобы выполнить задание
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                maxWidth: 340,
                margin: '0 auto 24px auto',
                boxSizing: 'border-box',
              }}
            >
              <FlyerCpcWidget
                onClose={() => {
                  setShowFlyerCpc(false);
                  setCpcProgress((prev) => prev + 1);
                }}
              />
            </div>
            <div
              style={{
                fontSize: 'clamp(14px, 2.5vw, 13px)',
                marginBottom: '3vw',
                marginTop: '6vw',
                textAlign: 'center',
              }}
            >
              *Остерегайтесь мошенников, подписываться необязательно.
            </div>
          </div>
        </div>
      )} */}

      {/* Task Action Modal */}
      <TaskActionModal
        isOpen={showTaskModal}
        onClose={() => setShowTaskModal(false)}
        task={task}
        onExecuteTask={handleExecuteTask}
        onCheckTask={handleCheckTask}
        isProcessing={isProcessing}
      />
    </>
  );
};

const TaskItem = memo(
  TaskItemInner,
  (prev, next) =>
    prev.task.id === next.task.id &&
    prev.task.status === next.task.status &&
    prev.task.buttonText === next.task.buttonText &&
    prev.task.progress?.current === next.task.progress?.current &&
    prev.task.progress?.total === next.task.progress?.total &&
    prev.task.timeRemaining === next.task.timeRemaining &&
    prev.task.rewards?.stars === next.task.rewards?.stars,
);

export default TaskItem;
